import type { QuantitySelectionAtomizedProps } from '@packages/modules/src/QuantitySelectionAtomized/QuantitySelectionAtomized';
import { QuantitySelectionAtomized } from '@packages/modules/src/QuantitySelectionAtomized/QuantitySelectionAtomized';
import { Divider } from '@packages/shared/src/ui/Divider/Divider';
import type { HTMLAttributes } from 'react';

export type QuantitySelectionProps = HTMLAttributes<HTMLDivElement> & {
  quantitySelectionProps?: QuantitySelectionAtomizedProps['quantitySelectionProps'];
};

export const QuantitySelection = ({ quantitySelectionProps, ...props }: QuantitySelectionProps) => (
  <div {...props}>
    <Divider />
    <QuantitySelectionAtomized
      quantitySelectionProps={quantitySelectionProps}
      hideLabel={false}
      className="my-1.5"
    />
    <Divider />
  </div>
);
